// extracted by mini-css-extract-plugin
module.exports = {"comp":"CompareA_comp__Jinrg"};